import { get } from 'lodash'

import { getTranslatedString, Institution } from '@skinsoft/types'

export const id = (institution: Institution) => get(institution, 'id');

export const title = (institution: Institution, locale: string) => getTranslatedString(get(institution, 'translatedTitle'), locale);